import YmapsModal from "./YmapsModal";

(() => {
    const initYmapsModal = () => {
        Array.from(document.querySelectorAll('.slope-map-modal')).forEach(modal => {
            new YmapsModal(modal);
        });
    };

    initYmapsModal();
})();
